import { Home, Mail, FileText, Users, List, Share2, Settings, BookOpen, Calendar, Lightbulb, Rocket } from 'lucide-react';

export interface NavItem {
  label: string;
  path: string;
  icon: any;
  matchPaths?: string[];
}

export const mainNavItems: NavItem[] = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: Home,
    matchPaths: ['/dashboard']
  },
  {
    label: 'Aan de slag',
    path: '/aan-de-slag',
    icon: Rocket,
  },
  {
    label: 'Ideeën',
    path: '/ideeen',
    icon: Lightbulb,
    matchPaths: ['/ideeen']
  },
  {
    label: 'Campagnes',
    path: '/campaigns',
    icon: Mail,
    matchPaths: ['/campaigns', '/campaign']
  },
  {
    label: 'Mijn Blogs',
    path: '/my-blogs',
    icon: FileText,
    matchPaths: ['/my-blogs', '/blog/edit']
  },
  {
    label: 'Mailinglijst',
    path: '/mailinglist',
    icon: List,
    matchPaths: ['/mailinglist']
  },
  {
    label: 'Social Media',
    path: '/social-media/posts',
    icon: Share2,
    matchPaths: ['/social-media']
  },
  {
    label: 'Activiteit',
    path: '/activiteit',
    icon: Calendar,
    matchPaths: ['/activiteit']
  },
];

export const bottomNavItems: NavItem[] = [
  {
    label: 'Kennisbank',
    path: '/kennisbank',
    icon: BookOpen,
    matchPaths: ['/kennisbank']
  },
  {
    label: 'Instellingen',
    path: '/dashboard/settings',
    icon: Settings,
    matchPaths: ['/dashboard/settings']
  }
];

export function isPathActive(currentPath: string, navItem: NavItem): boolean {
  if (navItem.path === currentPath) return true;

  if (navItem.matchPaths) {
    return navItem.matchPaths.some(matchPath => {
      if (matchPath === currentPath) return true;
      if (currentPath.startsWith(matchPath + '/')) return true;
      return false;
    });
  }

  return false;
}
